import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import ThemePage from "@/pages/ThemePage";
import SchoolsPage from "@/pages/SchoolsPage";
import AboutPage from "@/pages/AboutPage";
import { fetchProject } from "@/lib/api";
import { I18nProvider } from "@/lib/i18n";
import { SoundProvider } from "@/lib/sound";
import { useVisitTracker } from "@/lib/tracking";

function AppShell() {
    const [project, setProject] = useState(null);
    useVisitTracker();

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            try {
                const data = await fetchProject();
                if (!cancelled) setProject(data);
            } catch (e) {
                /* noop */
            }
        };
        load();
        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <div className="App min-h-screen flex flex-col relative">
            {/* Faded brand watermark background */}
            <div
                aria-hidden="true"
                className="pointer-events-none fixed inset-0 -z-10 opacity-[0.035]"
                style={{
                    backgroundImage: "url(/images/stemcycle-g2b-logo.jpg)",
                    backgroundRepeat: "repeat",
                    backgroundSize: "240px 240px",
                    mixBlendMode: "multiply",
                }}
            />
            <BrowserRouter>
                <Header />
                <main className="flex-1">
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/theme/:slug" element={<ThemePage />} />
                        <Route path="/schools" element={<SchoolsPage />} />
                        <Route path="/about" element={<AboutPage />} />
                    </Routes>
                </main>
                <Footer project={project} />
            </BrowserRouter>
        </div>
    );
}

function App() {
    return (
        <I18nProvider>
            <SoundProvider>
                <AppShell />
            </SoundProvider>
        </I18nProvider>
    );
}

export default App;
